export enum DonorProfileType {
    EditPaired = 1,
    Edit = 2,
    EditSelfRegistered = 3
}